import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8674920"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "right-model",
  ref: "rightModel"
}
const _hoisted_2 = { class: "menu-box" }
const _hoisted_3 = { class: "menu-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "PC端功能列表", -1))
const _hoisted_5 = { class: "block-tree" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-outstanding" }, null, -1))
const _hoisted_7 = { class: "menu-middle" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "移动端功能列表", -1))
const _hoisted_9 = { class: "block-tree" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-outstanding" }, null, -1))
const _hoisted_11 = { class: "menu-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "数据列表", -1))
const _hoisted_13 = { class: "block-tree" }
const _hoisted_14 = {
  key: 0,
  class: "extra"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工单数据", -1))
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "应用系统")
], -1))
const _hoisted_19 = { class: "select-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tree = _resolveComponent("Tree")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "content",
      style: _normalizeStyle(_ctx.readonlyStyle)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Tree, {
              checkable: !_ctx.readonly,
              disabled: _ctx.readonly,
              "tree-data": _ctx.leftTreeGrant,
              showIcon: true,
              replaceFields: { key: 'id'},
              checkedKeys: _ctx.leftCheckedKeys,
              "onUpdate:checkedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.leftCheckedKeys) = $event)),
              expandedKeys: _ctx.leftExpandData,
              "onUpdate:expandedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leftExpandData) = $event)),
              onCheck: _cache[2] || (_cache[2] = (value,e) => _ctx.handleCheck(value,e, 'pc')),
              onExpand: _cache[3] || (_cache[3] = (value) => _ctx.handleExpand(value, 'pc'))
            }, {
              buttonIcon: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["checkable", "disabled", "tree-data", "checkedKeys", "expandedKeys"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Tree, {
              checkable: !_ctx.readonly,
              disabled: _ctx.readonly,
              "tree-data": _ctx.appTreeGrant,
              showIcon: true,
              replaceFields: { key: 'id'},
              checkedKeys: _ctx.appCheckedKeys,
              expandedKeys: _ctx.appExpandData,
              "onUpdate:expandedKeys": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appExpandData) = $event)),
              onCheck: _cache[5] || (_cache[5] = (value,e) => _ctx.handleCheck(value,e, 'app')),
              onExpand: _cache[6] || (_cache[6] = (value) => _ctx.handleExpand(value, 'app'))
            }, {
              buttonIcon: _withCtx(() => [
                _hoisted_10
              ]),
              title: _withCtx(({title,id}) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.selectedMustIds.includes(id)?'disabled':'')
                }, _toDisplayString(title), 3)
              ]),
              _: 1
            }, 8, ["checkable", "disabled", "tree-data", "checkedKeys", "expandedKeys"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Tree, {
              checkable: !_ctx.readonly,
              disabled: _ctx.readonly,
              "tree-data": _ctx.rightTreeGrant,
              replaceFields: { key: 'id'},
              checkedKeys: _ctx.rightCheckedKeys,
              "onUpdate:checkedKeys": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rightCheckedKeys) = $event)),
              expandedKeys: _ctx.rightExpandData,
              "onUpdate:expandedKeys": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rightExpandData) = $event)),
              onCheck: _cache[9] || (_cache[9] = (value, e) => _ctx.handleCheck(value,e, 'xcx')),
              onExpand: _cache[10] || (_cache[10] = (value) => _ctx.handleExpand(value, 'xcx'))
            }, null, 8, ["checkable", "disabled", "tree-data", "checkedKeys", "expandedKeys"]),
            (_ctx.showTicketConfig)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "data",
                      id: "allData",
                      value: "allData",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.radioCheck) = $event)),
                      disabled: _ctx.disabled
                    }, null, 8, _hoisted_16), [
                      [_vModelRadio, _ctx.radioCheck]
                    ]),
                    _createElementVNode("label", {
                      for: "allData",
                      class: _normalizeClass(_ctx.disabled?'label-disabled':'')
                    }, "全量工单数据", 2)
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "data",
                      id: "personalData",
                      value: "personalData",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.radioCheck) = $event)),
                      disabled: _ctx.disabled
                    }, null, 8, _hoisted_17), [
                      [_vModelRadio, _ctx.radioCheck]
                    ]),
                    _createElementVNode("label", {
                      for: "personalData",
                      class: _normalizeClass(_ctx.disabled?'label-disabled':'')
                    }, "个人工单数据", 2)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "terminal-box",
        style: _normalizeStyle(_ctx.readonlyStyle)
      }, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terminals, (term) => {
            return (_openBlock(), _createElementBlock("div", {
              key: term.value
            }, [
              _createVNode(_component_Checkbox, {
                checked: term.checked,
                "onUpdate:checked": ($event: any) => ((term.checked) = $event),
                disabled: term.disabled,
                onChange: _ctx.terminalsCheckedChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(term.label), 1)
                ]),
                _: 2
              }, 1032, ["checked", "onUpdate:checked", "disabled", "onChange"])
            ]))
          }), 128))
        ])
      ], 4)
    ], 4)
  ], 512))
}